export default __webpack_public_path__ + "static/media/map.215aa535.png";